import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { PasswordInput } from "./Inputs";
import { useParams } from 'react-router-dom'
import { postStuff } from '../helpers/auth'
import "../css/login.css";
import { AlertsContext } from "./Layout";
import { Link } from "react-router-dom";



function ResetPasswordConfirmPage() {

    const { uid, token } = useParams()

    const [passInput, setPassInput] = useState("");
    const [passInput2, setPassInput2] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const addAlertBanner = useContext(AlertsContext);
    let navigate = useNavigate();


    const handleSubmit = (event) => {
        event.preventDefault();
        setErrorMessage("");
        if (passInput === "" || passInput2 === "") {
            setErrorMessage("Vyplňte všechny údaje");
            return;
        } else if (passInput2 !== passInput) {
            setErrorMessage("Hesla se neshodují");
            return;
        }

        setIsLoading(true);

        const body = {
            uid: uid,
            token: token,
            new_password: passInput,
            re_new_password: passInput2
        }


        postStuff("auth/users/reset_password_confirm/", body).then((res) => {
            console.log(res)
            try {
                setIsLoading(false);
                if (res.status === 204) {
                    addAlertBanner("Obnovení hesla proběhlo úspěšně", "success", 3000);
                    navigate('/login')
                }
                else if (res.status === 400) {
                    addAlertBanner("hesla se neshodují", "danger");
                }
                else {
                    addAlertBanner("Něco se pokazilo", "danger");
                }
            } catch (err) {
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });

    };

    return (
        <>
            <main className="mainContent">
                <header className="banner">
                    <img
                        loading="lazy"
                        src="/img/logo_text_bg.png"
                        alt="Peer Sight Logo"
                    />
                    <section className="systemInfo">Chytrý evidenční systém</section>
                </header>
                <section className="loginSection">
                    <form className="loginForm" onSubmit={handleSubmit}>
                        <p className="formTitle">Resetování hesla</p>
                        <PasswordInput passInput={passInput} setPassInput={setPassInput} />
                        <PasswordInput passInput={passInput2} setPassInput={setPassInput2} />
                        <label htmlFor="password" className="visually-hidden">
                            Enter your password
                        </label>
                        <button type="submit" className="submitButton" disabled={isLoading}>
                            Resetovat heslo
                        </button>
                        {errorMessage && <div className="form-error-mess">{errorMessage}</div>}
                    </form>
                    <div className="login-info">
                        <div className="forgotPassword">
                            Zapomněli jste heslo? Nastavte si nové{" "}
                            <a href="#" className="resetLink">
                                zde
                            </a>
                            .
                        </div>
                        <p className="accountRequest">
                            Pro vytvoření uživatelského účtu požádejte administrátora vaší
                            organizace.
                        </p>
                    </div>
                </section>
            </main>
        </>
    );
}

export default ResetPasswordConfirmPage;